__turbopack_context__.v({
  "areas": "styles-module-scss-module__YlJUpW__areas",
  "audience": "styles-module-scss-module__YlJUpW__audience",
  "detail": "styles-module-scss-module__YlJUpW__detail",
  "inner": "styles-module-scss-module__YlJUpW__inner",
  "state": "styles-module-scss-module__YlJUpW__state",
  "wrapper": "styles-module-scss-module__YlJUpW__wrapper",
});
